import axiosInstance from './axiosConfig';
import { ProductResponse, PaginatedProductResponse } from '../types/product';

export const productService = {
    async getPersonalProducts(): Promise<ProductResponse> {
        try {
            const response = await axiosInstance.get('/products/personal');
            // The backend returns { products: [...], currentPage: 0, ... }
            return { success: true, data: response.data.products || [] };
        } catch (error: any) {
            console.error('Failed to fetch personal products:', error);
            return { success: false, error: error.response?.data?.message || 'Failed to fetch products' };
        }
    },

    async getBusinessProducts(): Promise<ProductResponse> {
        try {
            const response = await axiosInstance.get('/products/business');
            // The backend returns { products: [...], currentPage: 0, ... }
            return { success: true, data: response.data.products || [] };
        } catch (error: any) {
            console.error('Failed to fetch business products:', error);
            return { success: false, error: error.response?.data?.message || 'Failed to fetch products' };
        }
    },

    async getPersonalProductsPaginated(page: number = 0, size: number = 9): Promise<PaginatedProductResponse> {
        try {
            const response = await axiosInstance.get(`/products/personal?page=${page}&size=${size}`);
            return { success: true, data: response.data };
        } catch (error: any) {
            console.error('Failed to fetch personal products:', error);
            return { success: false, error: error.response?.data?.message || 'Failed to fetch products' };
        }
    },

    async getBusinessProductsPaginated(page: number = 0, size: number = 9): Promise<PaginatedProductResponse> {
        try {
            const response = await axiosInstance.get(`/products/business?page=${page}&size=${size}`);
            return { success: true, data: response.data };
        } catch (error: any) {
            console.error('Failed to fetch business products:', error);
            return { success: false, error: error.response?.data?.message || 'Failed to fetch products' };
        }
    }
};